import { all, takeEvery, fork, put, select } from "redux-saga/effects";
import { push } from "react-router-redux";
import {
  MEMBER_LOGIN_TRIGGER,
  MEMBER_LOGOUT_TRIGGER,
  MEMBER_AUTH_REFRESH,
  MEMBER_TOKEN_LOADED,
  MEMBER_AUTH_LOADED,
  ASK_FOR_OTP,
  ASK_FOR_DATA,
  CALL_CENTER
} from "./AuthActions";
import Api from "WebsiteApp/logic/api/Api";

/**
 * Logout user
 *
 * @param {Object} action
 */
function* loginMember(action) {
  try {

    if(action.payload && !action.payload.isTemporary) {
      window.localStorage.setItem("AUTH_TOKEN", action.payload.token);
      window.sessionStorage.setItem("AUTH_TOKEN", action.payload.token);
    }

    yield put({ type: MEMBER_AUTH_LOADED, payload: action.payload.account });
  } catch (e) {}
}

function* logoutMember(action) {
  try {
    window.localStorage.removeItem("AUTH_TOKEN", action.payload.token);
    window.sessionStorage.removeItem("AUTH_TOKEN", action.payload.token);
  } catch (e) {}
}

function* refreshAuth(action) {
  try {
    const state = yield select();
    let token = state && state.auth && state.auth.token ? state.auth.token : null;

    if(!token) {
      token = window.sessionStorage.getItem("AUTH_TOKEN");
    }

    if (token) {
      yield put({ type: MEMBER_TOKEN_LOADED, payload: token });
      let result = yield Api.call("member/me");

      if (result.success) {
        yield put({ type: MEMBER_AUTH_LOADED, payload: result.data });
      }
    }
  } catch (e) {}
}

export function* redirectToPath(path) {
  yield put(push(path));
}

// function* handleOTPAskForData(payload) {
//   console.log("handleOtpAskForData:", payload);
//   const { request, retries } = payload
//     ? payload.payload
//     : { request: "email", retries: 3 };
//   yield put(
//     push("/otp-register", {
//       request: request,
//       retries: retries
//     })
//   );
// }

// function* handleAskForOTP(payload) {
//   console.log("handleAskForOTP:", payload);
//   const { timer, retries } = payload
//     ? payload.payload
//     : { timer: "email", retries: 3 };
//   yield put(
//     push("/otp-confirm", {
//       timer: timer,
//       retries: retries
//     })
//   );
// }

export function* watchMemberLogin() {
  yield takeEvery(MEMBER_LOGIN_TRIGGER, loginMember);
}
export function* watchMemberLogout() {
  yield takeEvery(MEMBER_LOGOUT_TRIGGER, logoutMember);
}
export function* watchRefreshAuth() {
  yield takeEvery(MEMBER_AUTH_REFRESH, refreshAuth);
}

// export function* watchAuthNextStep() {
//   yield takeLatest(CALL_CENTER, () => redirectToPath("/otp-centre"));
//   yield takeLatest(ASK_FOR_DATA, handleOTPAskForData);
//   yield takeLatest(ASK_FOR_OTP, handleAskForOTP);
// }

export default function* authSagas() {
  yield all([
    fork(watchMemberLogin),
    fork(watchMemberLogout),
    fork(watchRefreshAuth)
    // fork(watchAuthNextStep)
  ]);
}



// WEBPACK FOOTER //
// ./src/modules/auth/AuthSagas.js